// Utility helpers to normalize and display user role values from the API.
// Role values are string enums ('Administrator','User') as per the updated API.

export type RoleValue = string | number | null | undefined;

/**
 * Normalize role value to string enum format used by current API
 */
export function normalizeRoleToString(role: RoleValue): 'Administrator' | 'User' | undefined {
  if (role === 1 || role === '1' || role === 'Administrator') return 'Administrator';
  if (role === 2 || role === '2' || role === 'User') return 'User';
  return undefined;
}

export function roleLabel(role: RoleValue): string {
  const normalized = normalizeRoleToString(role);
  if (normalized === 'Administrator') return 'Administrator';
  if (normalized === 'User') return 'User';
  return '—';
}

export function roleBadgeClass(role: RoleValue): string {
  const normalized = normalizeRoleToString(role);
  if (normalized === 'Administrator') return 'bg-error/10 text-error text-xs px-2 py-1 rounded-full font-medium';
  if (normalized === 'User') return 'bg-secondary/10 text-secondary text-xs px-2 py-1 rounded-full font-medium';
  return '';
}

export default {
  normalizeRoleToString,
  roleLabel,
  roleBadgeClass,
};
